module.exports = __webpack_public_path__ + "img/mail_icon.f5679741.svg";